/** The done set, in `IssueStatus` declaration order. */
export const FINISHED_ISSUE_STATUSES = ['resolved', 'verified', 'closed'];
/**
 * Is this row finished?
 *
 * Fails toward SHOWING: a status we do not recognise is one we cannot claim is
 * done, and hiding it would drop the row off every surface with nothing on
 * screen to say so.
 */
export function isFinishedIssueStatus(status) {
    return FINISHED_ISSUE_STATUSES.includes(status);
}
/**
 * How many rows this toggle is removing from THIS list.
 *
 * Deliberately a count over the list the caller is about to render, not over
 * the project: on the extension and in Team Review the surface holds a window
 * (a page of 100, a fetch of 200), so a project-wide number would be a claim
 * the caller cannot see. "N rows here are hidden" is true on every surface.
 */
export function countFinishedIssues(issues) {
    let n = 0;
    for (const issue of issues)
        if (isFinishedIssueStatus(issue.status))
            n += 1;
    return n;
}
/**
 * The Status filter's default selection, the "Active issues" view (Emily,
 * 2026-09-24; prototype docs/prototypes/issues-filter-checkboxes.html). It
 * replaced the separate "Hide finished" checkbox on the dashboard, extension
 * and Team Review, so all three read the default from here.
 */
export const ACTIVE_ISSUE_STATUSES = ['open', 'in-progress'];
const asList = (selected) => (Array.isArray(selected) ? selected : [...selected]);
/**
 * Is this Status selection the Active view? True for the Active pair in any
 * order and for an EMPTY selection: unticking both defaults on the way to
 * ticking another status must never flash an empty list.
 */
export function isActiveStatusView(selected) {
    const list = asList(selected);
    if (list.length === 0)
        return true;
    return list.length === ACTIVE_ISSUE_STATUSES.length
        && ACTIVE_ISSUE_STATUSES.every((s) => list.includes(s));
}
/**
 * Apply a Status selection. The Active view hides finished rows and keeps any
 * status it does not recognise (failing toward showing, as above); any other
 * selection shows exactly those statuses.
 */
export function applyStatusView(issues, selected) {
    if (isActiveStatusView(selected))
        return issues.filter((i) => !isFinishedIssueStatus(i.status));
    const list = asList(selected);
    return issues.filter((i) => list.includes(i.status));
}
/**
 * How many rows the Active view is hiding from THIS list, for the
 * "N finished issues hidden" line. Zero for any explicit selection, which
 * hides nothing it was not asked about.
 */
export function countHiddenByStatusView(issues, selected) {
    return isActiveStatusView(selected) ? countFinishedIssues(issues) : 0;
}
/** All statuses is a visibility choice, not a restriction to clear with a search. */
export function isAllStatusView(selected) {
    const list = asList(selected);
    return [...ACTIVE_ISSUE_STATUSES, ...FINISHED_ISSUE_STATUSES].every(status => list.includes(status));
}
//# sourceMappingURL=issueStatuses.js.map